export default "__VITE_ASSET__cc1d693b__"